module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAHCAYAAADam2dgAAAAUUlEQVR42m3KMREAIQwF0VwBJQbQgAt0ggkaXOABBSj4t12a7Mzr1iRlTAwki5K05G2UaOp48g5qNDZceRctGiuOvIcejQVb3sIXjQkDE9noBw6mhG8jE2+lAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ideate/left-beam-2.png
// module id = 183
// module chunks = 35783957827783 112966903596346 114276838955818